import React from 'react'

import { Video, VideoProps } from '@makyoapp/makyo-tw-ui'

export type CompVideoProps = VideoProps

/**
 * CompVideoCore
 */
export const CompVideoCore = React.memo(Video)

CompVideoCore.displayName = 'CompVideoCore'

// import { CSSProperties } from 'react'

// import { validateImageUrl } from '@/shared/utils'

// import { convertRatioFormat } from '../../shared'

// export interface CompVideoProps {
//   margin?: CSSProperties
//   colorVariant?: string
//   styles?: CSSProperties
//   progressTop?: boolean
//   hideVolume?: boolean
//   hideControls?: boolean
//   shape?: MdShape
//   aspectRatio?: AspectRatio
//   wrapperStyle?: CSSProperties
//   isEmbed?: boolean
//   srcUrl?: string
//   realCover?: string
//   width?: string
//   align?: string
//   backgroundColor?: string
// }

// /**
//  * CompVideoCore
//  */
// export function CompVideoCore({
//   margin,
//   colorVariant,
//   styles,
//   progressTop,
//   hideVolume,
//   hideControls,
//   shape,
//   aspectRatio,
//   wrapperStyle,
//   isEmbed,
//   srcUrl,
//   realCover,
//   width = '100%',
//   align = 'center',
//   backgroundColor,
// }: CompVideoProps) {
//   return (
//     <div style={{ ...margin }}>
//       <Video
//         videoUrl={srcUrl}
//         posterUrl={validateImageUrl(realCover ?? '')}
//         aspectRatio={convertRatioFormat(aspectRatio ?? '')}
//         backgroundColor={backgroundColor}
//         containerWidth={width}
//         alignment={align as 'center' | 'left' | 'right'}
//         hideControls={hideControls}
//         hideVolumeControl={hideVolume}
//         cornerRadius={shape}
//       />
//     </div>

//     // <div className='w-full flex' style={{ ...wrapperStyle }}>
//     //   <MdVideo
//     //     isEmbed={isEmbed}
//     //     style={{
//     //       ...styles,
//     //       ...padding,
//     //       width: styles?.width ?? '100%',
//     //     }}
//     //     embedOptions={
//     //       {
//     //         maxWidth: styles?.width ?? '100%',
//     //         maxHeight: 'auto',
//     //       } as never
//     //     }
//     //     src={srcUrl}
//     //     variant={colorVariant as 'primary'}
//     //     poster={validateImageUrl(realCover ?? '')}
//     //     ratio={aspectRatio as AspectRatio}
//     //     progressTop={progressTop}
//     //     hideVolume={hideVolume}
//     //     shape={shape}
//     //   />
//     // </div>
//   )
// }
